import React, { useEffect, useState } from "react";
import Sidenav from "../Navbar/sideNav/page";
import HeaderSection from "../Navbar/page";
import FooterSection from "../footer/page";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RingLoader } from "react-spinners";
import Api from "../Api/Api";

function Page() {
  const location = useLocation();
  const data = location.state?.level;
  const [loading, setLoading] = useState(false);
  const [games, setGames] = useState([]);
  const [lengthGames, setLengthGames] = useState(0);
  const navigate = useNavigate();
  const [totalPageData, setTotalPageData] = useState(
    location.state?.level?.gameIds?.length
  );
  // console.log("Location", data)
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const gameData = {
    game: 
    // Array.from({ length: lengthGames }, (_, i) => ({
      games.map((id, index) => ({
      id: index + 1,
      name: `Game ${index + 1}`,
      gameId: id
    }))
  };
  
  // const indexOfLast = (currentPage-1) * itemsPerPage;
  // const indexOfFirst = indexOfLast - itemsPerPage;
  const totalPages = Math.ceil(lengthGames / itemsPerPage); 
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = gameData?.game?.slice(startIndex, startIndex + itemsPerPage);

  const handlePagination = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const pageLimit = 5;
  const currentGroup = Math.floor((currentPage - 1) / pageLimit);
  const startPage = currentGroup * pageLimit + 1;
  const endPage = Math.min(startPage + pageLimit - 1, totalPages);
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  // console.log("currentItem", currentItems);
  
  const Auth = localStorage.getItem(`Quizetoken`);

  const fetchGames = async() => {
    try {
      setLoading(true)
      const res = await Api.get(`/user/gamesPerLevel?level=${data}`);
      setGames(res.data.result.reverse());
      setLengthGames(res.data.result.length);
      
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }
  useEffect(()=>{
    fetchGames()
  },[Auth]);
  // console.log("length", lengthGames)

  // const handlePagination = (pageNo) => {
  //   const totalPages = Math.ceil(totalPageData / itemsPerPage);
  //   if (currentPage < totalPages) setCurrentPage(currentPage + 1);

  //   if (currentPage > 1) setCurrentPage(currentPage - 1);
  // };

  // console.log("current page", currentPage);
  // console.log("item per page", itemsPerPage);
  
  
  // console.log("Location Game", location.state.level);
  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "30%", marginBottom: "20%" }}
        >
          {/* <Loader/> */}
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : (
        <>
          {/* <HeaderSection/> */}
          <section className="banner-section inner-banner position-relative about">
            <div className="shape-area">
              <img
                src="/assets/images/abs-items/bubble.png"
                className="shape-1"
                alt="icon"
              />
              <img
                src="/assets/images/abs-items/ellipse-7.png"
                className="shape-2"
                alt="icon"
              />
            </div>
            <div className="container position-relative">
              <div style={{ marginTop: "9%", cursor: "pointer" }}>
                <i class="fa fa-arrow-left" onClick={() => navigate(-1)}></i>
              </div>
              <div className="banner-content row justify-content-between">
                <div className="col-lg-6 col-md-10">
                  <div className="main-content">
                    <h2 className="visible-slowly-bottom display-four mb-6">
                      Games
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 col-md-10 d-grid align-items-end justify-content-end">
                  <div className="breadcrumb-area position-absolute end-0 bottom-0">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb m-0 py-3 px-8 fs-six d-flex align-items-end justify-content-end">
                        <li className="breadcrumb-item p-0 m-0">
                          <a onClick={() => navigate("/")}>Home</a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/leaderboard")}
                        >
                          Leaderboard
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Level {data}
                        </li>
                        {/* <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Games
                        </li> */}
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="faqs-section bettor-ranking overflow-hidden">
            <div className="pt-80 pb-80">
              <div className="container position-relative cus-z1">
                <div className="row d-flex justify-content-between">
                  <div className="col-lg-8 offset-2">
                    <h2 className="text-center mb-5">Level {data}</h2>
                    <div className="accordion" id="accordionFaqs">
                      <div className="accordion-item">
                        <div id="" className="accordion-collapse">
                          {lengthGames === 0 ? (
                            <div className="accordion-body">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5>No Game yet!</h5>
                              </div>
                            </div>
                          ) : (
                            currentItems?.map((item, index) => (
                              <>
                                <div className="accordion-body">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5>
                                      Game {lengthGames - startIndex - index}
                                    </h5>
                                    <Link
                                      to={`/Leaderscore/${item.gameId}`}
                                      className="flip1 box-stylee btn-box d-center"
                                    >
                                      View leaderboard
                                    </Link>
                                  </div>
                                </div>
                              </>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {lengthGames > 0 && totalPages > 1 && (
                <div
                  className="pok-pagination"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-easing="ease-in"
                >
                  <ul>
                    {currentPage != 1 ? (
                      <li>
                        <a
                          // className={currentPage === number ? "active" : ""}
                          // href="#0"
                          onClick={() => handlePagination(currentPage - 1)}
                          disabled={currentPage == 1}
                        >
                          <i className="fa-solid fa-angles-left"></i>
                        </a>
                      </li>
                    ) : (
                      ""
                    )}

                    {/* <li>
                      <a href="#0">01</a>
                    </li> */}
                    {/* {Array.from(
                    {
                      length: Math.ceil(data?.game?.length / itemsPerPage),
                    },
                    (_, i) => (
                      <React.Fragment key={i}>
                        <li>
                          <a onClick={() => handlePagination(i + 1)}>
                            {currentPage}
                          </a>
                        </li>
                        {i === Math.floor(14 / 2) && (
                          <li>
                            <span>...</span>
                          </li>
                        )}
                      </React.Fragment>
                    )
                  )} */}
                    {/* {Array.from(
                      { length: Math.ceil(data?.game?.length / itemsPerPage) },
                      (_, i) => (
                        <li key={i}>
                          <button
                            onClick={() => handlePagination(i + 1)}
                            className={currentPage === i + 1 ? "active" : ""}
                          >
                            {i + 1}
                          </button>
                        </li>
                      )
                    )} */}
                    {pageNumbers.map((number) => (
                      <li key={number}>
                        <a
                          onClick={() => handlePagination(number)}
                          className={currentPage === number ? "active" : ""}
                        >
                          {number}
                        </a>
                      </li>
                    ))}
                    {currentPage == pageNumbers[pageNumbers.length - 1] ? (
                      ""
                    ) : (
                      <li>
                        <a
                          // href="#0"
                          onClick={() => handlePagination(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          <i className="fa-solid fa-angles-right"></i>
                        </a>
                      </li>
                    )}
                  </ul>
                  {/* <div className="toggle-pagination">
                    <span>
                      Page {currentPage} of{" "}
                      {Math.round(totalPageData / itemsPerPage)} {totalPageData}
                    </span>
                  </div> */}
                </div>
              )}
            </div>
          </section>
          <FooterSection />
        </>
      )}
    </>
  );
}

export default Page;
